import React from 'react';

import { Text } from '@reckon-web/text';

import {
  currencyStringToNumber,
  numberToCurrencyString,
} from '../../../utils/currency-utils';

interface IActivityPropertyMoney {
  value?: string | null;
}

// ActivityProperty Money = 6
export const ActivityPropertyMoney = ({ value }: IActivityPropertyMoney) => {
  const formattedValue = () => {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    // just in case someone has seen "ooh, currency" and slapped a "$123" into the field
    // parse it using our normal parsing stuff for dollar amounts
    const parsedVal = currencyStringToNumber(value);
    if (isNaN(parsedVal)) {
      // we tried, doesn't parse, just return the string
      return value;
    }

    // reuse our standard formatting from elsewhere
    return numberToCurrencyString(parsedVal);
  };

  return (
    <Text size="small" weight="semibold">
      {formattedValue()}
    </Text>
  );
};
